import * as t from 'react';
import { forwardRef, memo } from 'react';

var s=({title:e,titleId:r,...o},a)=>t.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 16 16",fill:"currentColor",ref:a,"aria-labelledby":r,...o},e?t.createElement("title",{id:r},e):null,t.createElement("path",{d:"M3.85 5H1.32v6h2.53l2.84 2.28 1.63 1.31V1.41L6.69 2.72Zm3.47 7.5L4.21 10H2.32V6h1.89l3.11-2.5Z","data-name":"Path 32"}),t.createElement("path",{d:"m14.68 6.35-.7-.7-1.66 1.64-1.64-1.64-.7.7L11.61 8 10 9.65l.7.7 1.65-1.64L14 10.35l.7-.7L13 8Z","data-name":"Path 33"})),n=forwardRef(s),f=memo(n),d=f;

export { d as a };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-V52YQQ4T.mjs.map